import React, { Component } from 'react'
import {Provider}           from 'react-redux'
import store                from './reducers/index'
import Stage                from './containers/Stage'
import './styles/fonts.css'
import './styles/App.css'

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <div className="fullheight">
          <Stage />
        </div>
      </Provider>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js